"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isBoolean2 = _interopRequireDefault(require("lodash/isBoolean"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconsReact = require("../../icons-react");
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["disabled", "headRenderer", "optionRenderer", "options", "placeholder", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Select = /*#__PURE__*/function (_React$PureComponent) {
  function Select(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Select);
    _this = _callSuper(this, Select, [props]);
    var selectedValue = props.value,
      allowEmpty = props.placeholder,
      options = props.options;
    var value = selectedValue || !allowEmpty && options[0].value || null;
    _this.state = {
      focusedIndex: 0,
      isOpen: false,
      optionHeight: 36,
      value: value
    };
    _this.buttonsEls = [];
    _this.el = /*#__PURE__*/_react["default"].createRef();
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleOpen = _this.handleOpen.bind(_this);
    _this.handleRefButtons = _this.handleRefButtons.bind(_this);
    _this.handleRefTitle = _this.handleRefTitle.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.dispatchChangeEvent = _this.dispatchChangeEvent.bind(_this);
    _this.getClosestOptionIndex = _this.getClosestOptionIndex.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Select, _React$PureComponent);
  return (0, _createClass2["default"])(Select, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = this.state.value;
      if (nextProps.value !== value) {
        this.setState(function () {
          return {
            value: nextProps.value
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      var _this$state = this.state,
        focusedIndex = _this$state.focusedIndex,
        isOpen = _this$state.isOpen;
      if (prevState.focusedIndex !== focusedIndex || !prevState.isOpen && prevState.isOpen !== isOpen) {
        setTimeout(function () {
          return _this2.buttonsEls[focusedIndex].focus();
        });
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(_ref) {
      var relatedTarget = _ref.relatedTarget;
      if (!this.el.current.contains(relatedTarget)) {
        this.toggle(false);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref2) {
      var target = _ref2.target;
      var clickedElement = this.buttonsEls.find(function (buttonEl) {
        return buttonEl && buttonEl.contains(target);
      });
      if (!clickedElement) return;
      var value = clickedElement.dataset.value;
      if (!value) {
        return;
      }
      this.toggle(false, {
        value: value
      }, this.dispatchChangeEvent);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var _this3 = this;
      this.toggle(null, {
        focusedIndex: 0
      }, function () {
        var optionHeight = _this3.buttonsEls[0].parentElement.offsetHeight;
        _this3.setState({
          optionHeight: optionHeight
        });
      });
    }
  }, {
    key: "handleRefButtons",
    value: function handleRefButtons(component) {
      var element = _reactDom["default"].findDOMNode(component);
      this.buttonsEls.push(element);
    }
  }, {
    key: "handleRefTitle",
    value: function handleRefTitle(Component) {
      this.title = _reactDom["default"].findDOMNode(Component);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      var key = event.key;
      if (key === 'ArrowUp' || key === 'ArrowDown') {
        event.preventDefault();
        var direcion = key === 'ArrowUp' ? -1 : 1;
        var focusedIndex = this.getClosestOptionIndex(direcion);
        this.setState({
          focusedIndex: focusedIndex
        });
      }
      if (key === 'Escape') {
        this.toggle(false);
      }
    }

    /**
     * Возвращает индекс предыдущего или следующего option
     * @param {number} direction
     */
  }, {
    key: "getClosestOptionIndex",
    value: function getClosestOptionIndex(direction) {
      var length = this.props.options.length;
      var focusedIndex = this.state.focusedIndex;
      var nextIndex = focusedIndex + direction;
      if (nextIndex === length) {
        return 0;
      }
      if (nextIndex < 0) {
        return length - 1;
      }
      return nextIndex;
    }
  }, {
    key: "toggle",
    value: function toggle(force, state, callback) {
      var _this4 = this;
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, state), {}, {
          isOpen: (0, _isBoolean2["default"])(force) ? force : !prevState.isOpen
        });
      }, function () {
        var onToggle = _this4.props.onToggle;
        var isOpen = _this4.state.isOpen;
        onToggle(isOpen);
        if ((0, _isFunction2["default"])(callback)) {
          callback();
        }
      });
    }
  }, {
    key: "dispatchChangeEvent",
    value: function dispatchChangeEvent() {
      var onChange = this.props.onChange;
      var value = this.state.value;
      var event = new CustomEvent('change', {
        bubbles: true,
        detail: {
          value: value
        }
      });
      this.el.current.dispatchEvent(event);
      onChange(event);
      this.title.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props = this.props,
        disabled = _this$props.disabled,
        headRenderer = _this$props.headRenderer,
        optionRenderer = _this$props.optionRenderer,
        options = _this$props.options,
        placeholder = _this$props.placeholder,
        size = _this$props.size,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var _this$state2 = this.state,
        isOpen = _this$state2.isOpen,
        value = _this$state2.value,
        optionHeight = _this$state2.optionHeight;
      var selectedOption = (0, _find2["default"])(options, {
        value: value
      });
      var optionsHeight = optionHeight * size;
      return /*#__PURE__*/_react["default"].createElement(StyledSelect, (0, _extends2["default"])({}, props, {
        onBlur: this.handleBlur,
        ref: this.el
      }), /*#__PURE__*/_react["default"].createElement(StyledSelected, {
        functional: true,
        disabled: disabled,
        onClick: this.handleOpen,
        ref: this.handleRefTitle,
        onKeyDown: this.handleKeyPress
      }, selectedOption || !placeholder ? (0, _isFunction2["default"])(headRenderer) && headRenderer(selectedOption) || selectedOption.title : /*#__PURE__*/_react["default"].createElement(StyledPlaceholder, null, placeholder), !disabled && /*#__PURE__*/_react["default"].createElement(StyledStatusIcon, {
        open: isOpen
      })), /*#__PURE__*/_react["default"].createElement(StyledOptions, {
        hidden: !isOpen,
        height: optionsHeight
      }, options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement(StyledOption, {
          key: option.value,
          selected: option.value === value,
          "data-selected": option.value === value
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          "data-value": option.value,
          functional: true,
          onClick: _this5.handleChange,
          ref: _this5.handleRefButtons,
          onKeyDown: _this5.handleKeyPress
        }, (0, _isFunction2["default"])(optionRenderer) ? optionRenderer(option) : option.title));
      })));
    }
  }]);
}(_react["default"].PureComponent);
Select.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onToggle: _propTypes["default"].func,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequire,
    value: _propTypes["default"].string.isRequire
  }).isRequired).isRequired,
  headRenderer: _propTypes["default"].func,
  optionRenderer: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  size: _propTypes["default"].number,
  value: _propTypes["default"].string
};
Select.defaultProps = {
  className: '',
  disabled: false,
  headRenderer: null,
  onChange: Function.prototype,
  onToggle: Function.prototype,
  optionRenderer: null,
  placeholder: null,
  size: 5,
  value: ''
};
var StyledSelect = _styledComponents["default"].div.withConfig({
  displayName: "Select__StyledSelect",
  componentId: "sc-19bpt5u-0"
})(["background-color:#ffffff;border-radius:4px;color:#17181a;height:36px;line-height:36px;width:201px;"]);
var StyledStatusIcon = (0, _styledComponents["default"])(_iconsReact.Dropdown).withConfig({
  displayName: "Select__StyledStatusIcon",
  componentId: "sc-19bpt5u-1"
})(["width:9px;height:5px;path{fill:#000;}", ""], function (_ref3) {
  var open = _ref3.open;
  return open && "\n    transform: rotate(180deg);\n  ";
});
var StyledSelected = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Select__StyledSelected",
  componentId: "sc-19bpt5u-2"
})(["align-items:center;display:flex;height:100%;justify-content:space-between;padding:0 11px;width:100%;", ""], function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && "\n    cursor: default;\n    opacity: .5;\n    pointer-events: none;\n  ";
});
var StyledOptions = _styledComponents["default"].ul.withConfig({
  displayName: "Select__StyledOptions",
  componentId: "sc-19bpt5u-3"
})(["background-color:#fff;border-radius:4px;box-shadow:0 2px 10px 0 rgba(0,0,0,0.1);margin-top:10px;position:relative;z-index:2;overflow-y:auto;max-height:", "px;::before{border-bottom:7px solid #fff;border-left:8px solid transparent;border-right:8px solid transparent;content:'';height:0;left:50%;margin-left:-8px;position:absolute;top:-7px;width:0;}::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-thumb{background-color:#c2c5cc;border-radius:40px;}", ""], function (_ref5) {
  var height = _ref5.height;
  return height;
}, function (_ref6) {
  var hidden = _ref6.hidden;
  return hidden && "\n    display: none;\n  ";
});
var StyledOption = _styledComponents["default"].li.withConfig({
  displayName: "Select__StyledOption",
  componentId: "sc-19bpt5u-4"
})(["padding:0 3px;min-height:31px;line-height:31px;border-top:1px solid transparent;> button{height:100%;margin:2px 0;padding:0 8px;text-align:left;width:100%;}& + &{border-top:1px solid rgba(194,197,204,0.2);}&:first-child{border-radius:4px 4px 0 0;}&:last-child{border-radius:0 0 4px 4px;}", ""], function (_ref7) {
  var selected = _ref7.selected;
  return selected && "\n    color: #fff;\n    background-color: #007aff;\n  ";
});
var StyledPlaceholder = _styledComponents["default"].span.withConfig({
  displayName: "Select__StyledPlaceholder",
  componentId: "sc-19bpt5u-5"
})(["color:gray;"]);
Select.StyledSelected = StyledSelected;
Select.StyledOptions = StyledOptions;
Select.StyledOption = StyledOption;
Select.StyledStatusIcon = StyledStatusIcon;
var _default = exports["default"] = Select;